export const createInsightRegistry = (vertical, coachingType, companyIdSlug) => {
  // All frameworks/tools are now loaded dynamically from the backend API via /api/v1/frameworks
  // This function is kept for backwards compatibility but returns an empty array
  // The widget will fetch published frameworks from the API instead
  
  return [];
};

// Helper function to get available insights
export const getAvailableInsights = (registry, context) => {
  // Now handled by backend API - returns empty array
  return [];
};

// Helper function to get missing insights (ones that need more data to unlock)
export const getMissingInsights = (registry, context) => {
  // Now handled by backend API - returns empty array
  return [];
};

// Helper function to compute insight results
export const computeInsight = (insight, context) => {
  // Now handled by backend API - returns null
    return null;
};
